import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Profile from "../../../images/jakia.jpeg";
import "./About.css";

const About = () => {
  return (
    <div id="about">
      <div className="about">
        <h1 className="pt-3 text-center font-details title pb-3">ABOUT ME</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2 mr-2 ">
                <Image
                  className="profile justify-content-end"
                  alt="profile"
                  src={Profile}
                  thumbnail
                  fluid
                />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className=" align-items-start p-2 my-details rounded">
                Hi there! I am Jakia
                <br />
                <br />
                Full Stack Developer experienced in building production-grade web applications and AI powered systems.
                <br />
                <br />
                I work across frontend development, backend services, database design, automation, and AWS deployments. I enjoy owning systems end-to-end and turning complex requirements into clean, reliable solutions.
                <br />
                <br />
                Working with clients and teams, my goal is always driven towards
                providing an amazing experience with the highest level of quality
                and service.
                <br />
                <br />
                <div className="d-flex justify-content-start flex-wrap mt-4 gap-3 w-100">
                  <a href="#contact">
                    <Button variant="outline-primary">
                      Get In Touch
                    </Button>
                  </a>
                  <a
                    href="https://docs.google.com/document/d/11Dff_8M9k_OKW1WAY1-F6OlSbxIeIsITAfRa_mUFSmM/edit?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="outline-success">
                      My Resume
                    </Button>
                  </a>
                  <a
                    href="https://github.com/thejakia1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="outline-light">
                      GitHub
                    </Button>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/thejakia1/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="outline-info">
                      LinkedIn
                    </Button>
                  </a>
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
